module.exports = __webpack_public_path__ + "img/banner.50994964.jpeg";